<!--elsint disable  -->
<template>
    <nf-title-wrap>
        <div slot="header">
            身份认证
        </div>
        <div slot="content">
            <div class="ulBox">
                <ul>
                    <li>
                        <div class="left">
                            <img src="./img/renz.png">
                        </div>
                        <div class="center">
                            <div class="title">
                                实名认证
                                <img
                                    v-if="isVerified && !isVerified.certifyStatus"
                                    src="./img/verified_un@2x.png"
                                >
                                <img
                                    v-if="isVerified && isVerified.certifyStatus"
                                    src="./img/verified@2x.png"
                                >
                            </div>
                            <div class="number">
                                {{ isVerified?isVerified.idCrad?isVerified.idCrad.substring(0,4) +'**********'+ isVerified.idCrad.substring(isVerified.idCrad.length-4):'':'' }}
                            </div>
                        </div>
                        <div
                            class="right"
                            @click="handCertification"
                        >
                            点击实名认证
                        </div>
                    </li>
                    <li>
                        <div class="left">
                            <img src="./img/bang.png">
                        </div>
                        <div class="center">
                            <div class="title">
                                绑定手机
                            </div>
                            <div class="number">
                                {{ isVerified?isVerified.mobile?isVerified.mobile.substring(0,3) +'******'+ isVerified.mobile.substring(isVerified.mobile.length-2):"":"" }}
                            </div>
                        </div>
                        <div
                            class="right"
                            @click="handSystemUI"
                        >
                            修改
                        </div>
                    </li>
                    <li>
                        <div class="left">
                            <img src="./img/mima.png">
                        </div>
                        <div class="center">
                            <div class="title">
                                密码
                            </div>
                            <div class="number">
                                {{ isVerified?isVerified.hasPassword?"已设置":"未设置":"" }}
                            </div>
                        </div>
                        <div
                            class="right"
                            @click="handPassphrases"
                        >
                            修改
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 实名认证弹框 -->
            <nf-confirm
                :show.sync="show"
                title="实名认证"
                :append-to-body="true"
                :is-cancel-btn="false"
                :is-savel-btn="false"
                height="391px"
                width="555px"
            >
                <div
                    slot="content"
                    class="get_code"
                >
                    <el-form
                        ref="ruleForm"
                        :model="ruleForm"
                        :rules="rules"
                        :label-position="labelPosition"
                        label-width="90px"
                    >
                        <el-form-item
                            label="姓名："
                            prop="name"
                        >
                            <el-input
                                v-model="ruleForm.name"
                                placeholder="请输入您的真实姓名"
                                maxlength="20"
                                @input="change"
                            />
                        </el-form-item>
                        <el-form-item
                            label="身份证号："
                            prop="idCrad"
                        >
                            <el-input
                                v-model="ruleForm.idCrad"
                                placeholder="请输入您的身份证号"
                                maxlength="18"
                                @input="change"
                            />
                        </el-form-item>
                        <el-form-item label="手机号码：">
                            <el-col :span="14">
                                <el-input
                                    v-model="isVerified.mobile"
                                    maxlength="11"
                                    placeholder="电话号码"
                                    disabled
                                />
                            </el-col>
                            <el-col :span="10">
                                <el-button
                                    type="text"
                                    class="hoverColor"
                                    :disabled="disabled"
                                    @click="handleMsgBtnTap"
                                >
                                    {{ codeText }}
                                </el-button>
                            </el-col>
                        </el-form-item>
                        <el-form-item
                            prop="code"
                            label="验证码"
                        >
                            <el-input
                                v-model="ruleForm.code"
                                maxlength="6"
                                placeholder="验证码"
                                @input="change"
                            />
                        </el-form-item>
                        <el-form-item>
                            <span
                                v-throttle="3000"
                                class="bottom_btn"
                                @click="certificationConfirmed('ruleForm')"
                            >
                                提交
                            </span>
                        </el-form-item>
                    </el-form>
                </div>
            </nf-confirm>
            <!-- 修改手机号 第一层弹框 -->
            <nf-confirm
                :show.sync="flag"
                title="修改手机号"
                :append-to-body="true"
                :is-cancel-btn="false"
                :is-savel-btn="false"
                height="300px"
                width="555px"
            >
                <div
                    slot="content"
                    class="get_code get_idCrad"
                >
                    <div class="totas">
                        为了保证您的账号安全变更信息前要验证身份。
                    </div>
                    <h3>
                        验证方式
                    </h3>
                    <el-form
                        ref="cardForm"
                        :model="cardForm"
                        :rules="rules"
                        label-position="top"
                    >
                        <el-form-item>
                            <el-select
                                v-model="value"
                                placeholder="请选择"
                                style="width:350px"
                                @change="handChange(value)"
                            >
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    style="width:350px"
                                    :disabled="item.disabled"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if="isPhone==='mobile'"
                            label=" 验证码："
                        >
                            <div>
                                <el-col :span="17">
                                    <el-input
                                        v-model="cardForm.code"
                                        maxlength="6"
                                        placeholder="验证码"
                                        @input="change"
                                    />
                                </el-col>
                                <el-col :span="7">
                                    <el-button
                                        type="text"
                                        class="hoverColor"
                                        :disabled="disabled"
                                        @click="handsystemUICode"
                                    >
                                        {{ codeText1 }}
                                    </el-button>
                                </el-col>
                            </div>
                        </el-form-item>
                        <el-form-item
                            v-if="isPhone==='idCard'"
                            label="身份证号码："
                        >
                            <div>
                                <el-col :span="24">
                                    <el-input
                                        v-model="cardForm.idCrad"
                                        maxlength="18"
                                        style="width:350px"
                                        placeholder="身份证号码"
                                        @input="change"
                                    />
                                </el-col>
                            </div>
                        </el-form-item>
                        <el-form-item class="bottom_box">
                            <i
                                v-if="isPhone==='mobile'"
                                class="bottom_com"
                            >
                                手机已不再使用？请联系企业管理员更换手机号
                            </i>
                            <i
                                v-if="isPhone==='idCard'"
                                class="bottom_com"
                            >
                                无法验证？请联系企业管理员处理
                            </i>
                            <span
                                v-throttle="3000"
                                class="bottom_btn"
                                @click="systemUIConfirmed"
                            >
                                提交
                            </span>
                        </el-form-item>
                    </el-form>
                </div>
            </nf-confirm>
            <!-- 修改密码 第一层弹框 -->
            <nf-confirm
                :show.sync="open"
                title="修改密码"
                :append-to-body="true"
                :is-cancel-btn="false"
                :is-savel-btn="false"
                height="300px"
                width="555px"
            >
                <div
                    slot="content"
                    class="get_code"
                >
                    <div class="totas">
                        为了保证您的账号安全变更信息前要验证身份
                    </div>
                    <h3>
                        验证方式
                    </h3>
                    <el-form
                        ref="passForm"
                        :model="passForm"
                        :rules="rules"
                        label-position="top"
                    >
                        <el-form-item>
                            <el-select
                                v-model="value1"
                                placeholder="请选择"
                                style="width:330px"
                                @change="handChangePass(value1)"
                            >
                                <el-option
                                    v-for="item in optionPass"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    :disabled="item.disabled"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if="isPass==='mobile'"
                            label="验证码："
                        >
                            <el-col :span="17">
                                <el-input
                                    v-model="passForm.code"
                                    maxlength="6"
                                    placeholder="验证码"
                                    @input="change"
                                />
                            </el-col>
                            <el-col :span="7">
                                <el-button
                                    type="text"
                                    class="hoverColor"
                                    :disabled="disabled"
                                    @click="handpassphrasesCode"
                                >
                                    {{ codeText2 }}
                                </el-button>
                            </el-col>
                        </el-form-item>
                        <el-form-item
                            v-if="isPass==='pass'"
                            label="登录密码："
                        >
                            <el-col :span="17">
                                <el-input
                                    v-model="passForm.pass"
                                    type="password"
                                    maxlength="18"
                                    style="width:350px"
                                    placeholder="登录密码"
                                    @input="change"
                                />
                            </el-col>
                        </el-form-item>
                        <el-form-item class="bottom_box">
                            <i
                                v-if="isPass==='mobile'"
                                class="bottom_com"
                            >
                                手机已不再使用？请联系企业管理员更换手机号
                            </i>
                            <i
                                v-if="isPass==='pass'"
                                class="bottom_com"
                            >
                                无法验证？请联系企业管理员处理
                            </i>
                            <span
                                v-throttle="3000"
                                class="bottom_btn"
                                @click="passphrasesConfirmed"
                            >
                                提交
                            </span>
                        </el-form-item>
                    </el-form>
                </div>
            </nf-confirm>
            <!-- 修改手机号 第二层弹框  -->
            <nf-confirm
                :show.sync="upPhone"
                title="修改手机号码"
                :append-to-body="true"
                :is-cancel-btn="false"
                :is-savel-btn="false"
                height="300px"
                width="555px"
            >
                <div
                    slot="content"
                    class="get_code"
                >
                    <el-form
                        ref="upPhoneForm"
                        :model="upPhoneForm"
                        :rules="rules"
                        label-position="top"
                        label-width="100px"
                    >
                        <el-form-item
                            label="新手机号码"
                            prop="mobile"
                        >
                            <el-input
                                v-model="upPhoneForm.mobile"
                                maxlength="11"
                                placeholder="请输入新手机号码"
                                @input="change"
                            />
                        </el-form-item>
                        <el-form-item label="验证码：">
                            <div>
                                <el-col :span="17">
                                    <el-input
                                        v-model="upPhoneForm.code"
                                        maxlength="6"
                                        placeholder="验证码"
                                        @input="change"
                                    />
                                </el-col>
                                <el-col :span="7">
                                    <el-button
                                        type="text"
                                        class="hoverColor"
                                        :disabled="disabled"
                                        @click="handsystemUIPhone('upPhoneForm')"
                                    >
                                        {{ codeText3 }}
                                    </el-button>
                                </el-col>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                size="small"
                                type="primary"
                                style="height:40px;width:110px;fontSize:14px;marginTop:20px"
                                @click="handleCheckPhone"
                            >
                                提交
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </nf-confirm>
            <!-- 修改密码 第二层弹框  -->
            <nf-confirm
                :show.sync="upPass"
                title="修改密码"
                :append-to-body="true"
                :is-cancel-btn="false"
                :is-savel-btn="false"
                height="300px"
                width="555px"
            >
                <div
                    slot="content"
                    class="get_code"
                >
                    <el-form
                        ref="upPassForm"
                        :model="upPassForm"
                        :rules="rules"
                        label-position="top"
                        label-width="100px"
                    >
                        <el-form-item
                            label="设置密码："
                            prop="pass"
                        >
                            <el-input
                                v-model="upPassForm.pass"
                                type="password"
                                placeholder="请输入密码"
                                @input="change"
                            />
                        </el-form-item>
                        <el-form-item
                            label="重复密码："
                            prop="checkPass"
                        >
                            <el-input
                                v-model="upPassForm.checkPass"
                                type="password"
                                placeholder="请再次输入密码"
                                @input="change"
                            />
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                size="small"
                                type="primary"
                                style="height:40px;width:110px;fontSize:14px;marginTop:20px"
                                @click="handleCheckPass('upPassForm')"
                            >
                                提交
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </nf-confirm>
        </div>
    </nf-title-wrap>
</template>
<script>
import nfTitleWrap from './components/nfTitleWrap'
import nfConfirm from '@/components/nf-confirm';
import { getPersonCertify, startPersonCertify, requestSMSCode, updateMobileAuth, personCertifyMobile, resetPasswordNew, resetPasswordAuth, updateMobile } from '@/api/authentication';
import { getPubKey} from '@/api/login'
import JSEncrypt from 'jsencrypt'
import store from '@/store/index';

let timer = null
let timer1 = null
let timer2 = null
let timer3 = null
export default {
    components: {
        nfTitleWrap,
        nfConfirm
    },
    data () {
        let nameReg = /^[0-9a-zA-Z\u4e00-\u9fa5]{2,20}$/
        let validaIteName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入姓名'));
            } if (!nameReg.test(value)) {
                callback(new Error('请输入正确的姓名'))
            } else {
                callback()
            }
        }
        let phoneReg = /^1\d{10}$/
        let validaItePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号'));
            } if (!phoneReg.test(value)) {
                callback(new Error('请输入正确的手机号'))
            } else {
                callback()
            }
        }
        let codeReg = /^[a-zA-Z0-9]{6}$/
        let validaIteCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入验证码'));
            } if (!codeReg.test(value)) {
                callback(new Error('请输入正确的验证码'))
            } else {
                callback()
            }
        }
        let idCardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        let idCardRegAdd = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
        let validateIdCrad = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入身份证号'));
            }
            if (value) {
                if (value.length === 18) {
                    if (!idCardReg.test(value)) {
                        callback(new Error('请输入正确的身份证号'))
                    } else {
                        callback()
                    }
                } else if (value.length === 15) {
                    if (!idCardRegAdd.test(value)) {
                        callback(new Error('请输入正确的身份证号'))
                    } else {
                        callback()
                    }
                } else {
                    callback(new Error('请输入正确的身份证号'))
                }
            }
        }
        // let passREG = /^[0-9a-zA-Z_]{6,18}$/
        let validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            }
            if (value.length < 8 || value.length > 16) {
                callback(new Error('密码长度需为8~16位'));
            } 
            // 规则2: 包含两种及以上字符类型
            const hasNumber = /[0-9]/.test(value)
            const hasLower = /[a-z]/.test(value)
            const hasUpper = /[A-Z]/.test(value)
            const hasSpecial = /[!@#$%^&*()_+.]/.test(value)
            const typeCount = [hasNumber, hasLower, hasUpper, hasSpecial].filter(Boolean).length
            if (typeCount < 2) {
                callback(new Error('密码需包含数字、大写字母、小写字母、特殊字符(!@#$%^&*()_+.)中的两种及以上'));
            }else {
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.upPassForm.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            labelPosition: 'left',
            show: false,
            flag: false,
            open: false,
            upPass: false,
            upPhone: false,
            isPhone: 'mobile',
            isPass: 'mobile',
            ruleForm: {},
            cardForm: {},
            passForm: {},
            upPassForm: {},
            upPhoneForm: {},
            loginLoading: false,
            // 验证码按钮loading
            codeLoading: false,
            // 获取验证码按钮内容
            codeText: '获取短信验证码',
            codeText1: '获取短信验证码',
            codeText2: '获取短信验证码',
            codeText3: '获取短信验证码',
            // 倒计时总秒数
            disabled: false,
            com: 'code',
            isVerified: {},
            time: 60,
            time1: 60,
            time2: 60,
            time3: 60,
            rules: {
                name: [
                    { validator: validaIteName, trigger: 'blur' }
                ],
                idCrad: [
                    { validator: validateIdCrad, trigger: 'blur' }
                ],
                mobile: [
                    { validator: validaItePhone, trigger: 'blur' }
                ],
                code: [
                    { validator: validaIteCode, trigger: 'blur' }
                ],
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
            },
            value: 'mobile',
            value1: 'mobile',
            token: [],
            options: [],
            authType: 'MOBILE',
            passType: 'MOBILE',
            optionPass: [],
            comides: '',
            pubKeyId: '',
            pubKey:''
        }
    },
    computed: {
        listData () {
            return this.$store.state.corporationInfo
        },
        newUser () {
            return this.$store.state.newUser
        },
    },
    watch: {
        newUser: {
            handler (c) {
                store.commit('upNewUser', c);
            },
            deep: true
        }
    },
    async created () {
        this.getPreson()
        // 对内容进行加密
        const {code,data} = await getPubKey()
        if(code === 200){
            this.pubKeyId = data.pubKeyId
            this.pubKey = data.pubKey
        }
    },
    methods: {
        change () {
            this.$forceUpdate()
        },
        //修改手机号 弹框 里面的短信验证码按钮
        handsystemUIPhone (form) {
            this.$refs[form].validate(async (valid) => {
                if (valid) {
                    this.codeDown3()
                    let { data } = await requestSMSCode({ mobile: this.upPhoneForm.mobile })
                    try {
                        if (data) {
                            this.upPhoneForm.code = data.code
                        }
                    } catch (error) {
                        return error
                    }
                }
            })

        },
        //修改手机号 弹框 里面的确定按钮
        async handleCheckPhone () {
            let res = await updateMobile(this.upPhoneForm)
            try {
                if (res.code === 200) {
                    this.upPhone = false
                    this.getPreson()
                    this.$$message(res.msg, 'success')
                }
            } catch (error) {
                return error
            }
        },
        // 进入页面获取的数据
        async getPreson () {
            let { data } = await getPersonCertify()
            try {
                if (data) {
                    this.isVerified = data
                    localStorage.users = data.name
                    window.localStorage.newUser = JSON.stringify(data);
                    store.commit('upNewUser', JSON.parse(window.localStorage.newUser));
                    if (this.isVerified.certifyStatus) {
                        this.options = [{
                            value: 'mobile',
                            label: '手机号'
                        }, {
                            value: 'idCard',
                            label: '身份证号',
                        }]
                    } else {
                        this.options = [{
                            value: 'mobile',
                            label: '手机号'
                        }, {
                            value: 'idCard',
                            label: '身份证号',
                            disabled: true
                        }]
                    }
                    if (this.isVerified.hasPassword) {
                        this.optionPass = [{
                            value: 'mobile',
                            label: '手机号'
                        }, {
                            value: 'pass',
                            label: '登录密码验证'
                        }]
                    } else {
                        this.optionPass = [{
                            value: 'mobile',
                            label: '手机号'
                        }, {
                            value: 'pass',
                            label: '登录密码验证',
                            disabled: true
                        }]
                    }
                }
            } catch (error) {
                return error
            }
        },
        // 倒计时
        codeDown () {
            if (timer) {
                clearInterval(timer)
            }
            this.codeText = this.time + '秒后重新获取'
            this.disabled = true
            timer = setInterval(async () => {
                this.codeText = --this.time + '秒后重新获取'
                if (this.time <= 0) {
                    clearInterval(timer)
                    this.time = 60
                    this.codeText = '重新获取验证码'
                    this.disabled = false
                }
            }, 1000)
        },
        codeDown1 () {
            if (timer1) {
                clearInterval(timer1)
            }
            this.codeText1 = this.time1 + '秒后重新获取'
            this.disabled = true
            timer1 = setInterval(async () => {
                this.codeText1 = --this.time1 + '秒后重新获取'
                if (this.time1 <= 0) {
                    clearInterval(timer1)
                    this.time1 = 60
                    this.codeText1 = '重新获取验证码'
                    this.disabled = false
                }
            }, 1000)
        },
        codeDown2 () {
            if (timer2) {
                clearInterval(timer2)
            }
            this.codeText2 = this.time2 + '秒后重新获取'
            this.disabled = true
            timer2 = setInterval(async () => {
                this.codeText2 = --this.time2 + '秒后重新获取'
                if (this.time2 <= 0) {
                    clearInterval(timer2)
                    this.time2 = 60
                    this.codeText2 = '重新获取验证码'
                    this.disabled = false
                }
            }, 1000)
        },
        codeDown3 () {
            if (timer3) {
                clearInterval(timer3)
            }
            this.codeText3 = this.time3 + '秒后重新获取'
            this.disabled = true
            timer3 = setInterval(async () => {
                this.codeText3 = --this.time3 + '秒后重新获取'
                if (this.time3 <= 0) {
                    clearInterval(timer3)
                    this.time3 = 60
                    this.codeText3 = '重新获取验证码'
                    this.disabled = false
                }
            }, 1000)
        },
        //实名认证  弹框 点击获取验证码按钮
        async handleMsgBtnTap () {
            let fieldsToValidate = ['name', 'idCrad'];
            let _self = this;
            Promise.all(fieldsToValidate.map(item => {
                let p = new Promise(function (resolve) {
                    _self.$refs['ruleForm'].validateField(item, (error) => {
                        resolve(error)
                    })
                });
                return p;
            })).then(async (data) => {
                if (!data[0] && !data[1]) {
                    let obj = Object.assign({}, { mobile: this.isVerified.mobile, type: 'user' }, this.ruleForm)
                    let res = await startPersonCertify(obj)
                    try {
                        if (res.code === 200) {
                            this.codeDown()
                            this.$$message(res.msg, 'success')
                        }
                    } catch (err) {
                        return err
                    }
                }
                // data 里是各个字段的验证错误信息, 如果为空串则认为验证通过, 如果数组里全为空串则所有验证通过
                // 判断data 里是否全是空串
            })
        },
        //实名认证按钮
        async handCertification () {
            if (this.isVerified && this.isVerified.certifyStatus) {
                this.$$message('该用户已实名认证成功', 'warning')
            } else {
                this.show = true
                this.ruleForm = {}
                this.$nextTick(() => {
                    this.$refs.ruleForm.clearValidate()
                })
            }
            this.codeText = '获取短信验证码'
            this.disabled = false
        },
        // 修改手机号按钮
        handSystemUI () {
            this.flag = true
            this.codeText1 = '获取短信验证码'
            this.disabled = false
            this.cardForm = {}
            this.upPhoneForm = {}
        },
        // 修改密码 按钮
        handPassphrases () {
            this.open = true
            this.passForm = {}
            this.upPassForm = {}
            this.codeText2 = '获取短信验证码'
            this.disabled = false
            if (this.comides === 'idCard') {
                this.handChangePass('mobile')
            }
        },
        // 修改手机号 弹框获取验证码的按钮
        async handsystemUICode () {
            this.codeDown1()
            let { data } = await requestSMSCode({ mobile: this.isVerified.mobile })
            try {
                if (data) {
                    this.cardForm.code = data.code
                }
            } catch (error) {
                return error
            }
        },
        // 修改密码 弹框获取验证码的按钮
        async handpassphrasesCode () {
            this.codeDown2()
            let { data } = await requestSMSCode({ mobile: this.isVerified.mobile })
            try {
                if (data) {
                    this.passForm.code = data.code
                }
            } catch (error) {
                return error
            }
        },
        //实名认证 确定按钮   
        certificationConfirmed (form) {
            this.$refs[form].validate(async (valid) => {
                if (valid) {
                    let res = await personCertifyMobile({ authcode: this.ruleForm.code })
                    try {
                        if (res.code === 200) {
                            this.$$message(res.msg, 'success')
                            this.show = false
                            this.getPreson()
                        }
                    } catch (error) {
                        return error
                    }
                } else {
                    return false
                }
            })
        },
        //修改手机号 确定按钮
        systemUIConfirmed () {
            if (this.authType === 'MOBILE') {
                this.update(this.isVerified.mobile)
            } else if (this.authType === 'IDCARD') {
                this.update(this.cardForm.idCrad)
            }
        },
        //修改密码  确定按钮
        passphrasesConfirmed () {
            if (this.isPass === 'mobile') {
                this.updateMsg(this.passForm.code, '')
            } else if (this.isPass === 'pass') {
                this.updateMsg('', this.passForm.pass)
            }
        },
        // 修改手机号 选择验证方式
        handChange (val) {
            this.comides = val
            if (this.flag === true) {
                this.isPhone = val
                if (val === 'idCard') {
                    this.authType = 'IDCARD'

                } else if (val === 'mobile') {
                    this.authType = 'MOBILE'
                }
            } else {
                this.isPhone = false
            }
        },
        // 修改密码 选择验证方式
        handChangePass (val) {
            if (this.open === true) {
                this.isPass = val
                if (val === 'pass') {
                    this.passType = 'PASSWORD'
                } else if (val === 'mobile') {
                    this.passType = 'MOBILE'
                }
            } else {
                this.isPass = false
            }

        },
        // 修改手机号方法
        async update (val) {
            let res = await updateMobileAuth({
                authId: val,
                authType: this.authType,
                code: this.cardForm.code
            })
            try {
                if (res.code === 200) {
                    this.flag = false
                    this.cardForm = {}
                    this.getPreson()
                    setTimeout(() => {
                        this.upPhone = true
                        this.upPhoneForm = {}
                        this.disabled = false
                        this.$nextTick(() => {
                            this.$refs.upPhoneForm.clearValidate()
                        })
                    }, 500)
                }
            } catch (error) {
                return error
            }
        },
        // 修改密码方法
        async updateMsg (val, str) {
            // 对内容进行加密
            const encryptor = new JSEncrypt()  
            encryptor.setPublicKey(this.pubKey)
            let rsaPassWord = encryptor.encrypt(str)
            let res = await resetPasswordAuth({
                authType: this.passType,
                code: val,
                oldPassword: rsaPassWord,
                pubKeyId: this.pubKeyId,
            })
            try {
                if (res.code === 200) {
                    this.open = false
                    setTimeout(() => {
                        this.upPass = true
                        this.$nextTick(() => {
                            this.$refs.upPassForm.clearValidate()
                        })

                    }, 500)
                }
            } catch (error) {
                return error
            }
        },
        // 设置密码按钮 
        handleCheckPass (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let rsaPassWord = ''
                    // 对内容进行加密
                    const encryptor = new JSEncrypt()  
                    encryptor.setPublicKey(this.pubKey)
                    rsaPassWord = encryptor.encrypt(this.upPassForm.pass)
                    let res = await resetPasswordNew({
                        password: rsaPassWord,
                        pubKeyId: this.pubKeyId,
                    })
                    try {
                        if (res.code === 200) {
                            this.upPass = false
                            this.$$message(res.msg, 'success')
                            this.getPreson()
                        }
                    } catch (error) {
                        return error
                    }
                } else {
                    return false;
                }
            })
        }
    }
}

</script>

<style lang='scss' scoped>
.ulBox {
    ul {
        li {
            list-style-type: none;
            width: 800px;
            height: 105px;
            margin: 20px 0 0 20px;
            border: 1px solid rgba(234, 235, 239, 1);
            display: flex;
            .left {
                img {
                    width: 36px;
                    height: 36px;
                    margin: 35px;
                }
            }
            .center {
                flex: 1;
                display: flex;
                flex-direction: column;
                .title {
                    font-weight: 500;
                    color: rgba(32, 32, 32, 1);
                    line-height: 20px;
                    margin: 25px 15px 15px 0;
                }
                .number {
                    color: rgba(102, 102, 102, 1);
                    line-height: 20px;
                }
            }
            .right {
                display: inline-block;
                max-width: 85px;
                color: rgba(33, 84, 189, 1);
                line-height: 20px;
                font-size: 14px;
                margin: 40px 50px 45px 0;
                cursor: pointer;
            }
        }
    }
}
.title {
    img {
        display: inline-block;
        width: 56px;
        height: 17px;
        margin-left: 15px;
    }
}
.el-form,
.el-form--label-left {
    padding: 0 90px !important;
}
h3 {
    font-weight: 500;
    color: rgba(24, 24, 24, 1);
    line-height: 22px;
    font-size: 16px;
    display: inline-block;
    margin: 25px 0 10px 90px;
}
.totas {
    width: 336px;
    font-size: 16px;
    color: rgba(210, 74, 25, 1);
    line-height: 22px;
    display: inline-block;
    margin-left: 90px;
}
.hoverColor {
    margin-left: 10px;
}
.bottom_com {
    font-size: 12px;
    margin-top: 20px;
    display: inline-block;
    width: 265px;
}
.bottom_btn {
    display: inline-block;
    width: 70px;
    height: 32px;
    color: ghostwhite;
    background: rgba(33, 84, 189, 1);
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
}
.get_idCrad {
    .el-form-item__error {
        margin-left: 200px !important;
    }
}
</style>
